import React from "react";
import Slider from "react-slick";
const defaultImage = require('../../media/sancoIcon_trans.png');

export class ScrollerTv extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      speciesName: this.props.speciesName,
      boatScores: this.props.boatScores,
      boatClass: this.props.boatClass,
      classBoats: [],
      tiles: this.props.tiles
    }
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({boatScores: newProps.boatScores, rowWidth: newProps.rowWidth, tiles: newProps.tiles, boatClass: newProps.boatClass});
		if(newProps.boatClass) {
			this.classFilter();
		} else {
			this.getBoatScores();
		}
      console.log('New Props: ', newProps)
  }
    
  classFilter() {
      var scores = this.props.boatScores;
      var boatClass = this.props.boatClass;
      var classBoats = [];
      scores.forEach((boat) => {
          if(boat.boat.boatClass === boatClass && boat.boat.total > 0) {
              var lastF = this.getLastFishTime(boat.boat.speciesCounts);
              classBoats.push({
                  id: boat.boat.id,
                  boatClass: boat.boat.boatClass,
                  boatName: boat.boat.boatName,
                  boatThm: boat.boat.boatThm,
                  lastFishTime: boat.boat.lastFishTime,
                  lastSpeceiesFishTime: lastF[0],
                  total: boat.boat.total
              });
          }
      })
      this.scoreSortFilter(classBoats);
  }
	
	getBoatScores() {
      var scores = this.props.boatScores;
      var boats = [];
      scores.forEach((boat) => {
          if(boat.boat.total > 0) {
              var lastF = this.getLastFishTime(boat.boat.speciesCounts);
              boats.push({
                  id: boat.boat.id,
                  boatName: boat.boat.boatName,
                  boatThm: boat.boat.boatThm,
                  lastFishTime: boat.boat.lastFishTime,
                  lastSpeceiesFishTime: lastF[0],
                  total: boat.boat.total
              });
          }
      })
      this.scoreSortFilter(boats);
  }
    
  getLastFishTime(times){
      var timesArray = [];
      times.forEach((time) => {
          if(time.speciesTimes){
              time.speciesTimes.forEach((t) => {
                  var secs = new Date(t).getTime() / 1000;
                  timesArray.push(secs);
              })
          }
      })
      timesArray.sort((a, b) => b - a);
      
      return timesArray;
  }
    
  scoreSortFilter(boatScores) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    boatScores.sortOn("total", "lastSpeceiesFishTime");
    boatScores.reverse();
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
    var boatScoresArray = boatScores.filter(filterByTotal);
    var rank = 1;
    var bScores = [];
    boatScoresArray.forEach((boat) => {
      bScores.push({
        rank: rank++,
        boat: boat
      })
    })
      
    var topTenBoats = bScores.slice(0,11)

    this.setState({
        classBoats: topTenBoats
    })
  }
  
render() {
    if (this.state.classBoats && this.state.classBoats.length < 3) {
      var slides = this.state.classBoats.length;
    } else {
      var slides = 3;
    }
    var settings = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: slides,
      slidesToScroll: 3,
      swipeToSlide: true,
      vertical: true
    };
    return (
      <div className="scores">
        <div className="scroller_title_tv">
        <div className="billfish_title"> { this.state.boatClass } Billfish Division </div>
          </div>
        {this.state.classBoats.length > 0 ? <Slider {...settings}>
          {this.state.classBoats.map(boat => (
             <div id='rank-box' className="boatBox" style={{width: '90%', margin: 10, padding: 5}} key={boat.boat.id}>
             <div className='boatTotalRowTop'>
               <div className='boatTotalRankTop'># {boat.rank}</div>
               <div className='boatTotalNameTop'>{boat.boat.boatName}</div>
               <div className='boatTotalTotalTop'>{boat.boat.total} Pts</div>
             </div>
         </div>
          ))}
        </Slider> : <div className='boatTotalRankTop'>No Billfish Logged Yet</div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CompsTv/ScrollerTv.js